import { UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAIL } from '../actions/file_actions';

const initialState = {
  uploadedFileUrl: null,
  error: null,
};

const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        uploadedFileUrl: action.payload.url,
        error: null,
      };
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        uploadedFileUrl: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fileReducer;

